/* ==========================================================================
   HP LAB — state-manager.js
   Guarda el estado del diagnóstico en curso. No toca el DOM, no sabe nada
   de HTML. Solo guarda y entrega datos.
   ========================================================================== */
window.HPLab = window.HPLab || {};

HPLab.State = (function () {
  "use strict";

  var initial = function () {
    return {
      component: null,
      symptoms: [],
      questionList: [],
      currentQuestionIndex: 0,
      scores: {},
      brand: null,
      brandUrl: null,
      power: null,
      /* Datos de identificación del equipo/cargador para la búsqueda de
         producto compatible (paso posterior al resultado). Vive acá para
         que se conserve al navegar entre resultado ↔ búsqueda ↔ resultados. */
      equipment: {
        brand: "",
        model: "",
        productNumber: "",
        serial: "",
        voltage: "",
        amperage: "",
        watts: "",
        connector: "",
        batteryPartNumber: "",
        capacity: "",
        family: ""
      },
      photo: null, // { name, dataUrl }
      searchResults: null,
      heroImageUrl: "",
      collectionHandle: "",
      lastDiagnosis: null
    };
  };

  var state = initial();

  return {
    reset: function () {
      state = initial();
    },
    get: function () {
      return state;
    },
    setComponent: function (key) {
      state.component = key;
    },
    setSymptoms: function (arr) {
      state.symptoms = arr;
    },
    setQuestionList: function (list) {
      state.questionList = list;
      state.currentQuestionIndex = 0;
    },
    currentQuestion: function () {
      return state.questionList[state.currentQuestionIndex] || null;
    },
    hasMoreQuestions: function () {
      return state.currentQuestionIndex < state.questionList.length;
    },
    advanceQuestion: function () {
      state.currentQuestionIndex++;
    },
    addScore: function (key, delta) {
      if (!key) return;
      state.scores[key] = (state.scores[key] || 0) + delta;
    },
    setBrand: function (label, url) {
      state.brand = label;
      state.brandUrl = url;
    },
    setPower: function (label) {
      state.power = label;
    },
    setEquipmentField: function (field, value) {
      if (!state.equipment) state.equipment = initial().equipment;
      state.equipment[field] = value;
    },
    getEquipment: function () {
      return state.equipment;
    },
    setPhoto: function (name, dataUrl) {
      state.photo = { name: name, dataUrl: dataUrl };
    },
    clearPhoto: function () {
      state.photo = null;
    },
    getPhoto: function () {
      return state.photo;
    },
    setSearchResults: function (results) {
      state.searchResults = results;
    },
    getSearchResults: function () {
      return state.searchResults;
    },
    setHeroImage: function (url) {
      state.heroImageUrl = url || "";
    },
    getHeroImage: function () {
      return state.heroImageUrl;
    },
    setCollectionHandle: function (handle) {
      state.collectionHandle = handle || "";
    },
    getCollectionHandle: function () {
      return state.collectionHandle;
    },
    setLastDiagnosis: function (result) {
      state.lastDiagnosis = result || null;
    },
    getLastDiagnosis: function () {
      return state.lastDiagnosis;
    }
  };
})();
